import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import { formatAvailabilityLabel } from "@/components/Dispatch/format";
import type { DriverRow } from "@/types/driver";
import ContextTile from "./ContextTile";
import { changedAt, NO_VALUE } from "./contextFormat";

/** The calculated in-cab availability, with the heartbeat time it was derived from. */
export default function AvailabilityTile({ driver }: { driver: DriverRow }) {
  const value = driver.offline ? "Offline" : formatAvailabilityLabel(driver.calculatedAvailability);
  return (
    <ContextTile
      icon={<CheckCircleOutlineIcon sx={{ fontSize: 18 }} />}
      label="Availability"
      value={value || NO_VALUE}
      footnote={changedAt(driver.membershipAvailabilityUpdatedAt, "updated")}
    />
  );
}
